// Support IE Edge, react-app-polyfill must be the first line
import 'react-app-polyfill/ie11';
import React from 'react';
import { render } from 'react-dom';
import '../style/style.css';
import LoginApp from './LoginApp';

const APP_ID = 'login-app';
const element = document.createElement('div');
element.setAttribute('id', APP_ID);
document.body.appendChild(element);

render(<LoginApp />, document.getElementById(APP_ID));
